export default "__VITE_ASSET__CmDhMhTa__"